export default [
  {
    // =============================================================================
    // PROJECT LAYOUT ROUTES
    // =============================================================================
    path: '/project/:proj_id',
    component: () => import('@/layouts/ProjectLayout.vue'),
    meta:{
      authRequired: true
    },
    redirect: '/project/:proj_id/home',
    children: [
      // 프로젝트
      {
        path: 'back',
        name: 'project-back',
        redirect: '/home'
      },
      // 대시보드
      {
        path: 'home',
        name: 'project-home',
        component: () => import(/* webpackPrefetch: true */'@/views/project/ProjectHome.vue'),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: 'Home',
              active: true
            }
          ],
          pageTitle: 'Home',
          deviceRequired: true
        }
      },
      // 대시보드
      {
        path: 'dashboard',
        name: 'project-dashboard',
        component: () => import('@/views/project/dashboard/FactoryAccessDashboard/FactoryAccessDashboard.vue'),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
            },
            {
              title: '일 안전/장비현황',
              active: true
            }
          ],
          pageTitle: '일 안전/장비현황',
          deviceRequired: true
        }
      },
      // 대시보드 - 그래프
      {
        path: 'graph',
        name: 'project-graph',
        component: () => import('@/views/project/dashboard/GraphDashboard/GraphDashboard.vue'),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
            },
            {
              title: '안전보건 운영현황',
              active: true
            }
          ],
          pageTitle: '안전보건 운영현황',
          deviceRequired: true
        }
      },
      //그래프
      {
        path: 'test-graph',
        name: 'project-graph',
        component: () => import('@/views/project/Dashboard.vue'),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            }
          ],
          pageTitle: 'TEST',
          deviceRequired: true
        }
      },
      // 대시보드 상세보기
      {
        path: 'graph/:graphId',
        name: 'project-graph',
        component: () => import('@/views/graph-detail/Index'),
        meta: {
          activeCode: 'graph',
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
            },
            {
              title: '안전보건 운영현황',
              active: true
            }
          ],
          pageTitle: '안전보건 운영현황'
        }
      },
      // 회원관리 가입대기
      {
        path: 'standing-account-list',
        name: 'page-standing-account-list',
        meta: {
          activeCode: 'standing_account'
        },
        component: () => import('@/views/pages/standing-account/StandingAccountList.vue'),
      },
      {
        path: 'standing-account-detail/:id',
        name: 'page-standing-account-detail',
        meta: {
          activeCode: 'standing_account'
        },
        component: () => import('@/views/pages/standing-account/StandingAccountDetail.vue')
      },
      // 회원관리 가입승인
      {
        path: 'confirm-account-list',
        name: 'page-confirm-account-list',
        meta: {
          activeCode: 'standing_account'
        },
        component: () => import('@/views/pages/confirm-account/ConfirmAccountList.vue'),
      },
      {
        path: 'confirm-account-detail/:id',
        name: 'page-confirm-account-detail',
        meta: {
          activeCode: 'standing_account'
        },
        component: () => import('@/views/pages/confirm-account/ConfirmAccountDetail.vue')
      },
      // 회원관리
      {
        path: 'regist-account-list',
        name: 'page-regist-account-list',
        meta: {
          activeCode: 'regist_account'
        },
        component: () => import('@/views/pages/regist-account/RegistAccountList.vue'),
      },
      {
        path: 'regist-account-detail/:id',
        name: 'page-regist-account-detail',
        meta: {
          activeCode: 'regist_account'
        },
        component: () => import('@/views/pages/regist-account/RegistAccountDetail.vue')
      },
      // 업체관리
      {
        path: 'company-management-list',
        name: 'page-company-management-list',
        meta: {
          activeCode: 'company-management'
        },
        component: () => import('@/views/pages/company-management/CompanyManagementList.vue'),
      },
      {
        path: 'company-management-detail',
        name: 'page-company-management-create',
        meta: {
          activeCode: 'company-management'
        },
        component: () => import('@/views/pages/company-management/CompanyManagementDetail.vue')
      },
      {
        path: 'company-management-detail/:id',
        name: 'page-company-management-detail',
        meta: {
          activeCode: 'company-management'
        },
        component: () => import('@/views/pages/company-management/CompanyManagementDetail.vue')
      },
      {
        path: 'graph-detail/:graphId',
        name: 'project-graph-detail',
        component: () => import('@/views/graph-detail/Index'),
        meta: {
          activeCode: 'graph',
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
              active: true
            }
          ],
          pageTitle: '대시보드'
        }
      },

      // =============================================================================
      // 커뮤니티 / 공지사항
      // =============================================================================
      {
        path: 'community/businessnews',
        name: 'project-community-businessnews',
        component: () => import('@/views/community/CommunityBusinessnews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '공지사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '공지사항',
          activeCode: 'news'
        }
      },
      { // 커뮤니티 / 공지사항
        path: 'community/businessnews/create',
        name: 'project-community-businessnews-create',
        component: () => import('@/views/community/CommunityBusinessnewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '공지사항'},
            {title: '작성', active: true}
          ],
          pageTitle: '공지사항',
          activeCode: 'news'
        }
      },
      { // 커뮤니티 / 공지사항
        path: 'community/businessnews/:postId',
        name: 'project-community-businessnews-detail',
        component: () => import('@/views/community/CommunityBusinessnewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '공지사항'},
            {title: '상세', active: true}
          ],
          pageTitle: '공지사항',
          activeCode: 'news'
        }
      },
      { // 커뮤니티 / 공지사항
        path: 'community/businessnews/:postId/update',
        name: 'project-community-businessnews-update',
        component: () => import('@/views/community/CommunityBusinessnewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '공지사항'},
            {title: '수정', active: true}
          ],
          pageTitle: '공지사항',
          activeCode: 'news'
        }
      },
      { // 커뮤니티 / 공지사항
        path: 'community/businessnews/:postId/reply',
        name: 'project-community-businessnews-reply',
        component: () => import('@/views/community/CommunityBusinessnewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '공지사항'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '공지사항',
          activeCode: 'news'
        }
      },

      // =============================================================================
      // 커뮤니티 / Q&A
      // =============================================================================
      {
        path: 'community/qna',
        name: 'project-community-qna',
        component: () => import('@/views/community/CommunityQna.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          activeCode: 'qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'community/qna/create',
        name: 'project-community-qna-create',
        component: () => import('@/views/community/CommunityQnaCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '작성', active: true}
          ],
          pageTitle: 'Q&A',
          activeCode: 'qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'community/qna/:postId',
        name: 'project-community-qna-detail',
        component: () => import('@/views/community/CommunityQnaDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '상세', active: true}
          ],
          pageTitle: 'Q&A',
          activeCode: 'qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'community/qna/:postId/update',
        name: 'project-community-qna-update',
        component: () => import('@/views/community/CommunityQnaUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '수정', active: true}
          ],
          pageTitle: 'Q&A',
          activeCode: 'qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: 'community/qna/:postId/reply',
        name: 'project-community-qna-reply',
        component: () => import('@/views/community/CommunityQnaReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '답글', active: true}
          ],
          pageTitle: 'Q&A',
          activeCode: 'qna'
        }
      },

      // =============================================================================
      // 커뮤니티 / FAQ
      // =============================================================================
      {
        path: 'community/faq',
        name: 'project-community-faq',
        component: () => import('@/views/community/CommunityFaq.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'FAQ'},
            {title: '목록', active: true}
          ],
          pageTitle: 'FAQ',
          activeCode: 'faq'
        }
      },
      { // 커뮤니티 / FAQ
        path: 'community/faq/create',
        name: 'project-community-faq-create',
        component: () => import('@/views/community/CommunityFaqCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'FAQ'},
            {title: '작성', active: true}
          ],
          pageTitle: 'FAQ',
          activeCode: 'faq'
        }
      },
      { // 커뮤니티 / FAQ
        path: 'community/faq/:postId',
        name: 'project-community-faq-detail',
        component: () => import('@/views/community/CommunityFaqDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'FAQ'},
            {title: '상세', active: true}
          ],
          pageTitle: 'FAQ',
          activeCode: 'faq'
        }
      },
      { // 커뮤니티 / FAQ
        path: 'community/faq/:postId/update',
        name: 'project-community-faq-update',
        component: () => import('@/views/community/CommunityFaqUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'FAQ'},
            {title: '수정', active: true}
          ],
          pageTitle: 'FAQ',
          activeCode: 'faq'
        }
      },
      { // 커뮤니티 / FAQ
        path: 'community/faq/:postId/reply',
        name: 'project-community-faq-reply',
        component: () => import('@/views/community/CommunityFaqReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'FAQ'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: 'FAQ',
          activeCode: 'faq'
        }
      },

      // =============================================================================
      // 주요공지 / 경영책임자 지시사항
      // =============================================================================
      {
        path: 'announcement/businessnews',
        name: 'project-announcement-businessnews',
        component: () => import('@/views/community/announcement/Businessnews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '경영책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '경영책임자 지시사항',
          activeCode: 'announcement_businessnews'
        }
      },
      { // 주요공지 / 경영책임자 지시사항
        path: 'announcement/businessnews/create',
        name: 'project-announcement-businessnews-create',
        component: () => import('@/views/community/announcement/BusinessnewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '경영책임자 지시사항'},
            {title: '작성', active: true}
          ],
          pageTitle: '경영책임자 지시사항',
          activeCode: 'announcement_businessnews'
        }
      },
      { // 주요공지 / 경영책임자 지시사항
        path: 'announcement/businessnews/:postId',
        name: 'project-announcement-businessnews-detail',
        component: () => import('@/views/community/announcement/BusinessnewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '경영책임자 지시사항'},
            {title: '상세', active: true}
          ],
          pageTitle: '경영책임자 지시사항',
          activeCode: 'announcement_businessnews'
        }
      },
      { // 주요공지 / 경영책임자 지시사항
        path: 'announcement/businessnews/:postId/update',
        name: 'project-announcement-businessnews-update',
        component: () => import('@/views/community/announcement/BusinessnewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '경영책임자 지시사항'},
            {title: '수정', active: true}
          ],
          pageTitle: '경영책임자 지시사항',
          activeCode: 'announcement_businessnews'
        }
      },
      { // 주요공지 / 경영책임자 지시사항
        path: 'announcement/businessnews/:postId/reply',
        name: 'project-announcement-businessnews-reply',
        component: () => import('@/views/community/announcement/BusinessnewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '경영책임자 지시사항'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '경영책임자 지시사항',
          activeCode: 'announcement_businessnews'
        }
      },

      { // 안전·보건 주요 일정
        path: 'announcement/schedule',
        name: 'project-announcement-schedule',
        component: () => import('@/views/community/announcement/Schedule.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '안전·보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전·보건 주요 일정',
          activeCode: 'announcement_schedule'
        }
      },
      { // 주요공지 / 안전보건 주요 일정
        path: 'announcement/schedule/create',
        name: 'project-announcement-schedule-create',
        component: () => import('@/views/community/announcement/ScheduleCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '안전·보건 주요 일정'},
            {title: '작성', active: true}
          ],
          pageTitle: '안전·보건 주요 일정',
          activeCode: 'announcement_schedule'
        }
      },
      { // 주요공지 / 안전보건 주요 일정
        path: 'announcement/schedule/:postId',
        name: 'project-announcement-schedule-detail',
        component: () => import('@/views/community/announcement/ScheduleDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '안전·보건 주요 일정'},
            {title: '상세', active: true}
          ],
          pageTitle: '안전·보건 주요 일정',
          activeCode: 'announcement_schedule'
        }
      },
      { // 주요공지 / 안전보건 주요 일정
        path: 'announcement/schedule/:postId/update',
        name: 'project-announcement-schedule-update',
        component: () => import('@/views/community/announcement/ScheduleUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '안전·보건 주요 일정'},
            {title: '수정', active: true}
          ],
          pageTitle: '안전·보건 주요 일정',
          activeCode: 'announcement_schedule'
        }
      },
      { // 주요공지 / 안전보건 주요 일정
        path: 'announcement/schedule/:postId/reply',
        name: 'project-announcement-schedule-reply',
        component: () => import('@/views/community/announcement/ScheduleReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '안전·보건 주요 일정'},
            {title: '답글', active: true}
          ],
          pageTitle: '안전·보건 주요 일정',
          activeCode: 'announcement_schedule'
        }
      },

      // 주간업무
      {
        path: 'announcement/weeklywork/incheon',
        name: 'project-announcement-weeklywork-incheon',
        component: () => import('@/views/community/weeklywork/WeeklyWorkIncheon.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '인천공장'},
            {title: '목록', active: true}
          ],
          pageTitle: '인천공장',
          activeCode: 'weekly_work_incheon'
        }
      },
      { // 주요공지 / 주간업무 / 인천공장
        path: 'announcement/weeklywork/incheon/create',
        name: 'project-announcement-weeklywork-incheon-create',
        component: () => import('@/views/community/weeklywork/WeeklyWorkIncheonCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '인천공장'},
            {title: '작성', active: true}
          ],
          pageTitle: '인천공장',
          activeCode: 'weekly_work_incheon'
        }
      },
      { // 주요공지 / 주간업무 / 인천공장
        path: 'announcement/weeklywork/incheon/:postId',
        name: 'project-announcement-weeklywork-incheon-detail',
        component: () => import('@/views/community/weeklywork/WeeklyWorkIncheonDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '인천공장'},
            {title: '상세', active: true}
          ],
          pageTitle: '인천공장',
          activeCode: 'weekly_work_incheon'
        }
      },
      { // 주요공지 / 주간업무 / 인천공장
        path: 'announcement/weeklywork/incheon/:postId/update',
        name: 'project-announcement-weeklywork-incheon-update',
        component: () => import('@/views/community/weeklywork/WeeklyWorkIncheonUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '인천공장'},
            {title: '수정', active: true}
          ],
          pageTitle: '인천공장',
          activeCode: 'weekly_work_incheon'
        }
      },
      { // 주요공지 / 주간업무 / 인천공장
        path: 'announcement/weeklywork/incheon/:postId/reply',
        name: 'project-announcement-weeklywork-incheon-reply',
        component: () => import('@/views/community/weeklywork/WeeklyWorkIncheonReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '인천공장'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '인천공장',
          activeCode: 'weekly_work_incheon'
        }
      },

      {
        path: 'announcement/weeklywork/pohang',
        name: 'project-announcement-weeklywork-pohang',
        component: () => import('@/views/community/weeklywork/WeeklyWorkPohang.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '포항공장'},
            {title: '목록', active: true}
          ],
          pageTitle: '포항공장',
          activeCode: 'weekly_work_pohang'
        }
      },
      { // 주요공지 / 주간업무 / 포항공장
        path: 'announcement/weeklywork/pohang/create',
        name: 'project-announcement-weeklywork-pohang-create',
        component: () => import('@/views/community/weeklywork/WeeklyWorkPohangCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '포항공장'},
            {title: '작성', active: true}
          ],
          pageTitle: '포항공장',
          activeCode: 'weekly_work_pohang'
        }
      },
      { // 주요공지 / 주간업무 / 포항공장
        path: 'announcement/weeklywork/pohang/:postId',
        name: 'project-announcement-weeklywork-pohang-detail',
        component: () => import('@/views/community/weeklywork/WeeklyWorkPohangDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '포항공장'},
            {title: '상세', active: true}
          ],
          pageTitle: '포항공장',
          activeCode: 'weekly_work_pohang'
        }
      },
      { // 주요공지 / 주간업무 / 포항공장
        path: 'announcement/weeklywork/pohang/:postId/update',
        name: 'project-announcement-weeklywork-pohang-update',
        component: () => import('@/views/community/weeklywork/WeeklyWorkPohangUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '포항공장'},
            {title: '수정', active: true}
          ],
          pageTitle: '포항공장',
          activeCode: 'weekly_work_pohang'
        }
      },
      { // 주요공지 / 주간업무 / 포항공장
        path: 'announcement/weeklywork/pohang/:postId/reply',
        name: 'project-announcement-weeklywork-pohang-reply',
        component: () => import('@/views/community/weeklywork/WeeklyWorkPohangReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '포항공장'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '포항공장',
          activeCode: 'weekly_work_pohang'
        }
      },

      {
        path: 'announcement/weeklywork/dangjin',
        name: 'project-announcement-weeklywork-dangjin',
        component: () => import('@/views/community/weeklywork/WeeklyWorkDangjin.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '당진공장'},
            {title: '목록', active: true}
          ],
          pageTitle: '당진공장',
          activeCode: 'weekly_work_dangjin'
        }
      },
      { // 주요공지 / 주간업무 / 당진공장
        path: 'announcement/weeklywork/dangjin/create',
        name: 'project-announcement-weeklywork-dangjin-create',
        component: () => import('@/views/community/weeklywork/WeeklyWorkDangjinCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '당진공장'},
            {title: '작성', active: true}
          ],
          pageTitle: '당진공장',
          activeCode: 'weekly_work_dangjin'
        }
      },
      { // 주요공지 / 주간업무 / 당진공장
        path: 'announcement/weeklywork/dangjin/:postId',
        name: 'project-announcement-weeklywork-dangjin-detail',
        component: () => import('@/views/community/weeklywork/WeeklyWorkDangjinDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '당진공장'},
            {title: '상세', active: true}
          ],
          pageTitle: '당진공장',
          activeCode: 'weekly_work_dangjin'
        }
      },
      { // 주요공지 / 주간업무 / 당진공장
        path: 'announcement/weeklywork/dangjin/:postId/update',
        name: 'project-announcement-weeklywork-dangjin-update',
        component: () => import('@/views/community/weeklywork/WeeklyWorkDangjinUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '당진공장'},
            {title: '수정', active: true}
          ],
          pageTitle: '당진공장',
          activeCode: 'weekly_work_dangjin'
        }
      },
      { // 주요공지 / 주간업무 / 당진공장
        path: 'announcement/weeklywork/dangjin/:postId/reply',
        name: 'project-announcement-weeklywork-dangjin-reply',
        component: () => import('@/views/community/weeklywork/WeeklyWorkDangjinReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '당진공장'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '당진공장',
          activeCode: 'weekly_work_dangjin'
        }
      },

      {
        path: 'announcement/weeklywork/lab',
        name: 'project-announcement-weeklywork-lab',
        component: () => import('@/views/community/weeklywork/WeeklyWorkLab.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '연구소'},
            {title: '목록', active: true}
          ],
          pageTitle: '연구소',
          activeCode: 'weekly_work_lab'
        }
      },
      { // 주요공지 / 주간업무 / 연구소
        path: 'announcement/weeklywork/lab/create',
        name: 'project-announcement-weeklywork-lab-create',
        component: () => import('@/views/community/weeklywork/WeeklyWorkLabCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '연구소'},
            {title: '작성', active: true}
          ],
          pageTitle: '연구소',
          activeCode: 'weekly_work_lab'
        }
      },
      { // 주요공지 / 주간업무 / 연구소
        path: 'announcement/weeklywork/lab/:postId',
        name: 'project-announcement-weeklywork-lab-detail',
        component: () => import('@/views/community/weeklywork/WeeklyWorkLabDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '연구소'},
            {title: '상세', active: true}
          ],
          pageTitle: '연구소',
          activeCode: 'weekly_work_lab'
        }
      },
      { // 주요공지 / 주간업무 / 연구소
        path: 'announcement/weeklywork/lab/:postId/update',
        name: 'project-announcement-weeklywork-lab-update',
        component: () => import('@/views/community/weeklywork/WeeklyWorkLabUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '연구소'},
            {title: '수정', active: true}
          ],
          pageTitle: '연구소',
          activeCode: 'weekly_work_lab'
        }
      },
      { // 주요공지 / 주간업무 / 연구소
        path: 'announcement/weeklywork/lab/:postId/reply',
        name: 'project-announcement-weeklywork-lab-reply',
        component: () => import('@/views/community/weeklywork/WeeklyWorkLabReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '주요공지'},
            {title: '주간업무'},
            {title: '연구소'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '연구소',
          activeCode: 'weekly_work_lab'
        }
      },

      // 자료실
      {
        path: 'resource/safetyhealth',
        name: 'project-resource-safetyhealth',
        component: () => import('@/views/community/resource/SafetyHealth.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '안전보건 교육자료'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 교육자료',
          activeCode: 'resource_safety_health'
        }
      },
      { // 자료실 / 안전보건 교육자료
        path: 'resource/safetyhealth/create',
        name: 'project-resource-safetyhealth-create',
        component: () => import('@/views/community/resource/SafetyHealthCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '안전보건 교육자료'},
            {title: '작성', active: true}
          ],
          pageTitle: '안전보건 교육자료',
          activeCode: 'resource_safety_health'
        }
      },
      { // 자료실 / 안전보건 교육자료
        path: 'resource/safetyhealth/:postId',
        name: 'project-resource-safetyhealth-detail',
        component: () => import('@/views/community/resource/SafetyHealthDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '안전보건 교육자료'},
            {title: '상세', active: true}
          ],
          pageTitle: '안전보건 교육자료',
          activeCode: 'resource_safety_health'
        }
      },
      { // 자료실 / 안전보건 교육자료
        path: 'resource/safetyhealth/:postId/update',
        name: 'project-resource-safetyhealth-update',
        component: () => import('@/views/community/resource/SafetyHealthUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '안전보건 교육자료'},
            {title: '수정', active: true}
          ],
          pageTitle: '안전보건 교육자료',
          activeCode: 'resource_safety_health'
        }
      },
      { // 자료실 / 안전보건 교육자료
        path: 'resource/safetyhealth/:postId/reply',
        name: 'project-resource-safetyhealth-reply',
        component: () => import('@/views/community/resource/SafetyHealthReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '안전보건 교육자료'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '안전보건 교육자료',
          activeCode: 'resource_safety_health'
        }
      },

      {
        path: 'resource/environmentenergy',
        name: 'project-resource-environmentenergy',
        component: () => import('@/views/community/resource/EnviromentEnergy.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '환경에너지 교육자료'},
            {title: '목록', active: true}
          ],
          pageTitle: '환경에너지 교육자료',
          activeCode: 'resource_enviroment_energy'
        }
      },
      { // 자료실 / 환경에너지 교육자료
        path: 'resource/environmentenergy/create',
        name: 'project-resource-environmentenergy-create',
        component: () => import('@/views/community/resource/EnviromentEnergyCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '환경에너지 교육자료'},
            {title: '작성', active: true}
          ],
          pageTitle: '환경에너지 교육자료',
          activeCode: 'resource_enviroment_energy'
        }
      },
      { // 자료실 / 환경에너지 교육자료
        path: 'resource/environmentenergy/:postId',
        name: 'project-resource-environmentenergy-detail',
        component: () => import('@/views/community/resource/EnviromentEnergyDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '환경에너지 교육자료'},
            {title: '상세', active: true}
          ],
          pageTitle: '환경에너지 교육자료',
          activeCode: 'resource_enviroment_energy'
        }
      },
      { // 자료실 / 환경에너지 교육자료
        path: 'resource/environmentenergy/:postId/update',
        name: 'project-resource-environmentenergy-update',
        component: () => import('@/views/community/resource/EnviromentEnergyUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '환경에너지 교육자료'},
            {title: '수정', active: true}
          ],
          pageTitle: '환경에너지 교육자료',
          activeCode: 'resource_enviroment_energy'
        }
      },
      { // 자료실 / 환경에너지 교육자료
        path: 'resource/environmentenergy/:postId/reply',
        name: 'project-resource-environmentenergy-reply',
        component: () => import('@/views/community/resource/EnviromentEnergyReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '환경에너지 교육자료'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '환경에너지 교육자료',
          activeCode: 'resource_enviroment_energy'
        }
      },

      {
        path: 'resource/suppliescompany',
        name: 'project-resource-suppliescompany',
        component: () => import('@/views/community/resource/SuppliesCompanyEducation.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '수급업체 교육자료'},
            {title: '목록', active: true}
          ],
          pageTitle: '수급업체 교육자료',
          activeCode: 'resource_supplies_company_education'
        }
      },
      { // 자료실 / 수급업체 교육자료
        path: 'resource/suppliescompany/create',
        name: 'project-resource-suppliescompany-create',
        component: () => import('@/views/community/resource/SuppliesCompanyEducationCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '수급업체 교육자료'},
            {title: '작성', active: true}
          ],
          pageTitle: '수급업체 교육자료',
          activeCode: 'resource_supplies_company_education'
        }
      },
      { // 자료실 / 수급업체 교육자료
        path: 'resource/suppliescompany/:postId',
        name: 'project-resource-suppliescompany-detail',
        component: () => import('@/views/community/resource/SuppliesCompanyEducationDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '수급업체 교육자료'},
            {title: '상세', active: true}
          ],
          pageTitle: '수급업체 교육자료',
          activeCode: 'resource_supplies_company_education'
        }
      },
      { // 자료실 / 수급업체 교육자료
        path: 'resource/suppliescompany/:postId/update',
        name: 'project-resource-suppliescompany-update',
        component: () => import('@/views/community/resource/SuppliesCompanyEducationUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '수급업체 교육자료'},
            {title: '수정', active: true}
          ],
          pageTitle: '수급업체 교육자료',
          activeCode: 'resource_supplies_company_education'
        }
      },
      { // 자료실 / 수급업체 교육자료
        path: 'resource/suppliescompany/:postId/reply',
        name: 'project-resource-suppliescompany-reply',
        component: () => import('@/views/community/resource/SuppliesCompanyEducationReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '자료실'},
            {title: '수급업체 교육자료'},
            {title: '답글 작성', active: true}
          ],
          pageTitle: '수급업체 교육자료',
          activeCode: 'resource_supplies_company_education'
        }
      },

      { // 마이페이지 / 설정 / 개인정보변경
        path: 'mypage/info-update',
        name: 'project-mypage-info-update',
        component: () => import('@/views/mypage/MyPageInfoUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정'},
            {title: '개인정보변경', active: true}
          ],
          pageTitle: '개인정보변경',
          activeCode: 'project-mypage-info-update'
        }
      },
      { // 마이페이지 / 설정 / 개인서명관리
        path: 'mypage/sign-update',
        name: 'project-mypage-sign-update',
        component: () => import('@/views/mypage/MyPageSignUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정'},
            {title: '개인서명관리', active: true}
          ],
          pageTitle: '개인서명관리',
          activeCode: 'project-mypage-sign-update'
        }
      },
      { // 마이페이지 / 설정 / 기본문서관리
        path: 'mypage/document-update',
        name: 'project-mypage-sign-update',
        component: () => import('@/views/mypage/MyPageDocumentUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정'},
            {title: '기본문서관리', active: true}
          ],
          pageTitle: '기본문서관리',
          activeCode: 'project-mypage-document-update'
        }
      },
      { // 마이페이지 / 업무현황
        path: 'mypage/workstatus',
        name: 'project-mypage-workstatus',
        component: () => import('@/views/mypage/MyPageWorkStatus.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '업무현황', active: true}
          ],
          pageTitle: '업무현황',
          activeCode: 'project-mypage-workstatus'
        }
      },
      { // 마이페이지 / 알림
        path: 'mypage/alert',
        name: 'project-mypage-alert',
        component: () => import('@/views/mypage/MyPageAlert.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '알림', active: true}
          ],
          pageTitle: '알림',
          activeCode: 'project-mypage-alert'
        }
      },
      {
        path: 'approval-request',
        name: 'project-approval-request',
        component: () => import('@/views/approval/ApprovalRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '임시저장함',
              url: {name: 'project-approval-request'},
              active: true
            }
          ],
          pageTitle: '임시저장함'
        }
      },
      {
        path: 'approval-await',
        name: 'project-approval-await',
        component: () => import('@/views/approval/ApprovalAwait.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재대기함',
              url: {name: 'project-approval-await'},
              active: true
            }
          ],
          pageTitle: '결재대기함'
        }
      },
      {
        path: 'approval-document-company',
        name: 'project-approval-document-company',
        component: () => import('@/views/approval/ApprovalDocumentCompany.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '담당업무함'},
            {
              title: '담당업무함',
              url: {name: 'project-approval-document-company'},
              active: true
            }
          ],
          pageTitle: '담당업무함'
        }
      },
      {
        path: 'approval-dc-process-await',
        name: 'project-approval-dc-process-await',
        component: () => import('@/views/approval/DcApprovalProcessAwait.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '담당업무함'},
            {
              title: '결재미결함',
              url: {name: 'project-approval-dc-process-await'},
              active: true
            }
          ],
          pageTitle: '결재미결함'
        }
      },
      {
        path: 'approval-dc-process-approved',
        name: 'project-approval-dc-process-approved',
        component: () => import('@/views/approval/DcApprovalProcessApproved.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '담당업무함'},
            {
              title: '결재진행함',
              url: {name: 'project-approval-dc-process-approved'},
              active: true
            }
          ],
          pageTitle: '결재진행함'
        }
      },
      {
        path: 'approval-dc-complete',
        name: 'project-approval-dc-complete',
        component: () => import('@/views/approval/DcApprovalComplete.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '담당업무함'},
            {
              title: '완료문서함',
              url: {name: 'project-approval-dc-complete'},
              active: true
            }
          ],
          pageTitle: '완료문서함'
        }
      },
      {
        path: 'approval-dc-reject',
        name: 'project-approval-dc-reject ',
        component: () => import('@/views/approval/DcApprovalReject.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '담당업무함'},
            {
              title: '반려문서함',
              url: {name: 'project-approval-dc-reject'},
              active: true
            }
          ],
          pageTitle: '반려문서함'
        }
      },
      {
        path: 'approval-process',
        name: 'project-approval-process',
        component: () => import('@/views/approval/ApprovalProcess.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재진행함',
              url: {name: 'project-approval-process'},
              active: true
            }
          ],
          pageTitle: '결재진행함'
        }
      },
      {
        path: 'approval-process-await',
        name: 'project-approval-process-await',
        component: () => import('@/views/approval/ApprovalProcessAwait.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재미결함',
              url: {name: 'project-approval-process-await'},
              active: true
            }
          ],
          pageTitle: '결재미결함'
        }
      },
      {
        path: 'approval-process-approved',
        name: 'project-approval-process-approved',
        component: () => import('@/views/approval/ApprovalProcessApproved.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재진행함',
              url: {name: 'project-approval-process-approved'},
              active: true
            }
          ],
          pageTitle: '결재진행함'
        }
      },
      {
        path: 'approval-complete',
        name: 'project-approval-complete',
        component: () => import('@/views/approval/ApprovalComplete.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '완료문서함',
              url: {name: 'project-approval-complete'},
              active: true
            }
          ],
          pageTitle: '완료문서함'
        }
      },
      {
        path: 'approval-reject',
        name: 'project-approval-reject',
        component: () => import('@/views/approval/ApprovalReject.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '반려문서함',
              url: {name: 'project-approval-reject'},
              active: true
            }
          ],
          pageTitle: '반려문서함'
        }
      },
      {
        path: 'approval-reference',
        name: 'project-approval-reference',
        component: () => import('@/views/approval/ApprovalReference.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '참조/회람문서함',
              url: {name: 'project-approval-reference'},
              active: true
            }
          ],
          pageTitle: '참조/회람문서함'
        }
      },
    ]
  },
]
